import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

import { useLanguageContext } from "../../contexts/language-context";

/**
 * This component renders the modal triggered when we try to go to an external url.
 *
 * @param {Object} props - The object containing props.
 * @param {boolean} props.show - required boolean value to show or hide the modal.
 * @param {string} props.url - required string value used for the button to proceed and go to the external link.
 * @param {function} props.handleClose - required function to close the modal or cancel the process to go to the external link.
 * @returns {React.JSX.Element} Returns the JSX component to render.
 */
const ExternalModal = ({ show = false, url = "", handleClose = () => {} }) => {
  const goExternalLink = () => {
    handleClose();

    if (typeof window !== "undefined") {
      window.open(url, "_blank");
    }
  };

  const isSpanish = useLanguageContext();
  const labelsDictionary = {
    en: {
      leaving: "You're Leaving the WaFd Bank Website",
      externalLink: `You have clicked an external link. Please click "Proceed" to continue or "Cancel" to stay here.`,
      cancel: "Cancel",
      proceed: "Proceed"
    },
    es: {
      leaving: "Estás saliendo del sitio web de Wafd Bank",
      externalLink: `Ha hecho clic en un enlace externo. Haga clic en "Continuar" para continuar o "Cancelar" para permanecer aquí.`,
      cancel: "Cancelar",
      proceed: "Continuar"
    }
  };

  const labels = isSpanish ? labelsDictionary["es"] : labelsDictionary["en"];

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton id="external-modal-header">
        <strong>{labels.leaving}</strong>
      </Modal.Header>

      <Modal.Body id="external-modal-body">
        <p>{labels.externalLink}</p>
      </Modal.Body>
      <div className="border-top p-3">
        <div className="row">
          <div className="col-sm-6 mb-4 mb-sm-0">
            <button className="btn btn-link w-100" id="external-modal-cancel-btn" onClick={handleClose}>
              {labels.cancel}
            </button>
          </div>
          <div className="col-sm-6">
            <button className="btn btn-primary w-100" id="external-modal-proceed-btn" onClick={goExternalLink}>
              {labels.proceed}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalModal;

ExternalModal.propTypes = {
  show: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
};
